import Vue from 'vue';
import Vuex from 'vuex';
import ui from './modules/ui';
import clients from './modules/clients';
import documents from './modules/documents';
import settings from './modules/settings';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},

  getters: {},

  mutations: {},

  actions: {},

  modules: {
    ui,
    clients,
    documents,
    settings,
  },
});
